module.exports = __webpack_public_path__ + "sf-pro-text-light.svg?bffa5cb1dbb1ee25e6244cbcf81543ff";